import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '@seedkit/vue/stores';
import { usePermissionsStore } from 'app/src/shared/permissions/permissions.store';
import { filterMainMenuByRouter } from 'app/src/app/utils/filter-main-menu-by-router';

/**
 * Пункты главного меню, по которым уже можно безопасно строить RouterLink
 * (динамические маршруты модулей после IAM).
 */
export function useMainMenuFilteredByRouter() {
  const router = useRouter();
  const appState = useAppStore();
  const permissionsStore = usePermissionsStore();

  return computed(() => {
    void permissionsStore.loaded;
    void permissionsStore.routeRegistrationStamp;
    return filterMainMenuByRouter(appState.mainMenu, router);
  });
}
